(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["printmivo-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('printmivo-footer')) {
    customElements.define('printmivo-footer', class extends HTMLElement {
      connectedCallback() {
        this.toggles = Array.from(this.querySelectorAll('[data-pm-footer-toggle]'))
        this.toggles.forEach(toggle => toggle.addEventListener('click', () => {
          if (window.innerWidth > 749) return
          const content = this.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`)
          const open = toggle.getAttribute('aria-expanded') !== 'true'
          toggle.setAttribute('aria-expanded', open ? 'true' : 'false')
          if (content) content.hidden = !open
        }))
        this.onResize = () => {
          const desktop = window.innerWidth > 749
          this.toggles.forEach(toggle => {
            const content = this.querySelector(`#${CSS.escape(toggle.getAttribute('aria-controls'))}`)
            if (desktop) {
              toggle.setAttribute('aria-expanded', 'true')
              if (content) content.hidden = false
            }
          })
        }
        window.addEventListener('resize', this.onResize)
        this.onResize()
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize)
      }
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["printmivo-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('printmivo-header')) {
    customElements.define('printmivo-header', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return
        this.dataset.ready = 'true'
        this.siteNav = this.querySelector('.pm-site-nav')
        this.menuToggle = this.querySelector('[data-pm-menu-toggle]')
        this.menu = this.querySelector('[data-pm-menu]')
        this.megaMenu = this.querySelector('[data-pm-mega-menu]')
        this.megaOverlay = this.querySelector('[data-pm-mega-overlay]')
        this.megaTriggers = Array.from(this.querySelectorAll('[data-pm-mega-trigger]'))
        this.onDocumentClick = event => {
          if (!this.contains(event.target)) {
            this.closeMenu()
            this.closeMega()
          }
        }
        this.onKeyDown = event => {
          if (event.key !== 'Escape') return
          if (this.classList.contains('is-mega-open')) this.closeMega(true)
          else this.closeMenu(true)
        }
        this.onResize = () => {
          if (window.innerWidth > 989) this.closeMenu()
          else this.closeMega()
        }
        this.menuToggle?.addEventListener('click', () => this.toggleMenu())
        this.menu?.querySelectorAll('a').forEach(link => link.addEventListener('click', () => this.closeMenu()))
        this.megaTriggers.forEach(trigger => {
          trigger.addEventListener('mouseenter', () => this.openMega(trigger))
          trigger.addEventListener('focus', () => this.openMega(trigger))
        })
        this.siteNav?.addEventListener('mouseleave', () => this.closeMega())
        this.siteNav?.addEventListener('focusout', event => {
          if (!this.siteNav.contains(event.relatedTarget)) this.closeMega()
        })
        this.megaOverlay?.addEventListener('click', () => this.closeMega())
        document.addEventListener('click', this.onDocumentClick)
        document.addEventListener('keydown', this.onKeyDown)
        window.addEventListener('resize', this.onResize)
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick)
        document.removeEventListener('keydown', this.onKeyDown)
        window.removeEventListener('resize', this.onResize)
      }

      toggleMenu() {
        this.closeMega()
        const open = !this.classList.contains('is-menu-open')
        this.classList.toggle('is-menu-open', open)
        this.menuToggle?.setAttribute('aria-expanded', open ? 'true' : 'false')
      }

      closeMenu(returnFocus = false) {
        if (!this.classList.contains('is-menu-open')) return
        this.classList.remove('is-menu-open')
        this.menuToggle?.setAttribute('aria-expanded', 'false')
        if (returnFocus) this.menuToggle?.focus()
      }

      openMega(trigger) {
        if (window.innerWidth < 990 || !this.megaMenu || !this.megaOverlay) return
        this.activeMegaTrigger = trigger
        this.megaTriggers.forEach(item => item.setAttribute('aria-expanded', item === trigger ? 'true' : 'false'))
        const navBottom = this.siteNav?.getBoundingClientRect().bottom || 0
        this.style.setProperty('--pm-mega-top', `${Math.max(0, navBottom)}px`)
        this.megaMenu.hidden = false
        this.megaOverlay.hidden = false
        this.classList.add('is-mega-open')
      }

      closeMega(returnFocus = false) {
        if (!this.classList.contains('is-mega-open')) return
        this.classList.remove('is-mega-open')
        this.megaTriggers.forEach(item => item.setAttribute('aria-expanded', 'false'))
        if (this.megaMenu) this.megaMenu.hidden = true
        if (this.megaOverlay) this.megaOverlay.hidden = true
        if (returnFocus) this.activeMegaTrigger?.focus()
      }
    })
  }

  ;(() => {
    const setCartExpanded = expanded => {
      document.querySelectorAll('.pm-cart-link').forEach(link => link.setAttribute('aria-expanded', expanded ? 'true' : 'false'))
    }

    const openCartDrawer = (drawer, trigger) => {
      window.clearTimeout(drawer.printmivoCloseTimer)
      drawer.printmivoTrigger = trigger
      delete drawer.dataset.printmivoClosing
      drawer.style.setProperty('transition', 'background-color .8s cubic-bezier(.7, 0, .2, 1)', 'important')
      drawer.querySelector('.m-cart-drawer__inner')?.style.setProperty('transition', 'transform .6s cubic-bezier(.7, 0, .2, 1)', 'important')
      drawer.style.setProperty('--m-bg-opacity', '0')
      drawer.style.setProperty('--translate-x', '100%')
      drawer.classList.add('m-cart-drawer--active')
      document.documentElement.classList.add('prevent-scroll')
      setCartExpanded(true)
      window.requestAnimationFrame(() => window.requestAnimationFrame(() => {
        drawer.style.setProperty('--m-bg-opacity', '0.5')
        drawer.style.setProperty('--translate-x', '0')
      }))
    }

    const closeCartDrawer = drawer => {
      window.clearTimeout(drawer.printmivoCloseTimer)
      drawer.dataset.printmivoClosing = 'true'
      drawer.style.setProperty('transition', 'background-color .28s cubic-bezier(.7, 0, .2, 1)', 'important')
      drawer.querySelector('.m-cart-drawer__inner')?.style.setProperty('transition', 'transform .28s cubic-bezier(.7, 0, .2, 1)', 'important')
      drawer.style.setProperty('--m-bg-opacity', '0')
      drawer.style.setProperty('--translate-x', '100%')
      setCartExpanded(false)
      const closeDuration = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 800
      drawer.printmivoCloseTimer = window.setTimeout(() => {
        drawer.classList.remove('m-cart-drawer--active')
        delete drawer.dataset.printmivoClosing
        document.documentElement.classList.remove('prevent-scroll')
        drawer.printmivoTrigger?.focus()
      }, closeDuration)
    }

    const handleCartClick = event => {
      const drawer = document.querySelector('#MinimogCartDrawer')
      if (!drawer) return
      const cartLink = event.target.closest('.pm-cart-link')
      if (cartLink) {
        event.preventDefault()
        event.stopImmediatePropagation()
        openCartDrawer(drawer, cartLink)
        return
      }
      if (event.target.closest('.m-cart-drawer__close') || event.target === drawer) {
        event.preventDefault()
        event.stopImmediatePropagation()
        closeCartDrawer(drawer)
      }
    }

    const handleCartKeydown = event => {
      if (event.key !== 'Escape') return
      const drawer = document.querySelector('#MinimogCartDrawer.m-cart-drawer--active')
      if (!drawer) return
      event.preventDefault()
      event.stopImmediatePropagation()
      closeCartDrawer(drawer)
    }

    if (document.documentElement.dataset.printmivoCartMotion !== 'true') {
      document.documentElement.dataset.printmivoCartMotion = 'true'
      window.addEventListener('click', handleCartClick, true)
      window.addEventListener('keydown', handleCartKeydown, true)
    }

    const artworkUrl = link => {
      const raw = (link.getAttribute('href') || '').trim()
      if (!raw) return ''
      try {
        return new URL(raw, `${window.location.origin}/`).href
      } catch (_) {
        return ''
      }
    }

    const isArtworkLink = link => {
      const raw = link.getAttribute('href') || ''
      const nearbyText = [link, link.parentElement, link.closest('li, p, div, dd, td')]
        .filter(Boolean)
        .map(element => element.textContent || '')
        .join(' ')
      return /(?:file\?token=|\/uploads\/)/i.test(raw) && /artwork|logo/i.test(nearbyText)
    }

    const replaceArtworkLinks = () => {
      document.querySelectorAll('a').forEach(link => {
        if (link.dataset.printmivoArtworkPreview === 'true') return
        if (!isArtworkLink(link)) return
        const previewUrl = artworkUrl(link)
        if (!previewUrl) return
        link.dataset.printmivoArtworkPreview = 'true'
        link.setAttribute('aria-label', link.parentElement?.textContent?.split(':')[0]?.trim() || 'Artwork preview')
        const preview = document.createElement('img')
        preview.alt = ''
        preview.loading = 'lazy'
        preview.addEventListener('load', () => {
          link.classList.add('pm-artwork-preview')
          link.replaceChildren(preview)
        }, { once: true })
        preview.addEventListener('error', () => {
          delete link.dataset.printmivoArtworkPreview
        }, { once: true })
        preview.src = previewUrl
      })
    }

    let artworkTimer
    const scheduleArtworkPreview = () => {
      window.clearTimeout(artworkTimer)
      artworkTimer = window.setTimeout(replaceArtworkLinks, 60)
    }
    replaceArtworkLinks()
    new MutationObserver(scheduleArtworkPreview).observe(document.documentElement, { childList: true, subtree: true })
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["printmivo-home"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('printmivo-hero')) {
    customElements.define('printmivo-hero', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return
        this.dataset.ready = 'true'
        this.slides = Array.from(this.querySelectorAll('[data-pm-slide]'))
        this.dots = Array.from(this.querySelectorAll('[data-pm-dot]'))
        this.hero = this.querySelector('.pm-hero')
        this.siteNav = this.querySelector('.pm-site-nav')
        this.menuToggle = this.querySelector('[data-pm-menu-toggle]')
        this.menu = this.querySelector('[data-pm-menu]')
        this.megaMenu = this.querySelector('[data-pm-mega-menu]')
        this.megaOverlay = this.querySelector('[data-pm-mega-overlay]')
        this.megaTriggers = Array.from(this.querySelectorAll('[data-pm-mega-trigger]'))
        this.currentIndex = 0
        this.autoplay = Number(this.dataset.autoplay) || 6000
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)')
        this.onVisibilityChange = () => document.hidden ? this.stop() : this.start()
        this.onPointerDown = event => { this.pointerStart = event.clientX }
        this.onPointerUp = event => {
          if (typeof this.pointerStart !== 'number') return
          const distance = event.clientX - this.pointerStart
          this.pointerStart = null
          if (Math.abs(distance) < 45) return
          this.show(this.currentIndex + (distance < 0 ? 1 : -1))
          this.restart()
        }
        this.onDocumentClick = event => {
          if (!this.contains(event.target)) {
            this.closeMenu()
            this.closeMega()
          }
        }
        this.onKeyDown = event => {
          if (event.key === 'Escape') {
            if (this.classList.contains('is-mega-open')) this.closeMega(true)
            else this.closeMenu(true)
          }
          if (event.key === 'ArrowRight' && this.hero.contains(document.activeElement)) {
            this.show(this.currentIndex + 1)
            this.restart()
          }
          if (event.key === 'ArrowLeft' && this.hero.contains(document.activeElement)) {
            this.show(this.currentIndex - 1)
            this.restart()
          }
        }
        this.onResize = () => {
          if (window.innerWidth > 989) this.closeMenu()
          else this.closeMega()
        }

        this.dots.forEach((dot, index) => dot.addEventListener('click', () => {
          this.show(index)
          this.restart()
        }))
        this.menuToggle?.addEventListener('click', () => this.toggleMenu())
        this.menu?.querySelectorAll('a').forEach(link => link.addEventListener('click', () => this.closeMenu()))
        this.megaTriggers.forEach(trigger => {
          trigger.addEventListener('mouseenter', () => this.openMega(trigger))
          trigger.addEventListener('focus', () => this.openMega(trigger))
        })
        this.siteNav?.addEventListener('mouseleave', () => this.closeMega())
        this.siteNav?.addEventListener('focusout', event => {
          if (!this.siteNav.contains(event.relatedTarget)) this.closeMega()
        })
        this.megaOverlay?.addEventListener('click', () => this.closeMega())
        this.hero?.addEventListener('mouseenter', () => this.stop())
        this.hero?.addEventListener('mouseleave', () => this.start())
        this.hero?.addEventListener('focusin', () => this.stop())
        this.hero?.addEventListener('focusout', event => {
          if (!this.hero.contains(event.relatedTarget)) this.start()
        })
        this.hero?.addEventListener('pointerdown', this.onPointerDown, { passive: true })
        this.hero?.addEventListener('pointerup', this.onPointerUp, { passive: true })
        document.addEventListener('visibilitychange', this.onVisibilityChange)
        document.addEventListener('click', this.onDocumentClick)
        document.addEventListener('keydown', this.onKeyDown)
        window.addEventListener('resize', this.onResize)
        this.show(0)
        this.start()
      }

      disconnectedCallback() {
        this.stop()
        document.removeEventListener('visibilitychange', this.onVisibilityChange)
        document.removeEventListener('click', this.onDocumentClick)
        document.removeEventListener('keydown', this.onKeyDown)
        window.removeEventListener('resize', this.onResize)
      }

      show(index) {
        if (!this.slides.length) return
        this.currentIndex = (index + this.slides.length) % this.slides.length
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.currentIndex
          slide.classList.toggle('is-active', active)
          slide.setAttribute('aria-hidden', active ? 'false' : 'true')
          slide.toggleAttribute('inert', !active)
        })
        this.dots.forEach((dot, dotIndex) => {
          if (dotIndex === this.currentIndex) dot.setAttribute('aria-current', 'true')
          else dot.removeAttribute('aria-current')
        })
      }

      start() {
        if (this.slides.length < 2 || this.motionQuery.matches || document.hidden) return
        this.stop()
        this.timer = window.setInterval(() => this.show(this.currentIndex + 1), this.autoplay)
      }

      stop() {
        window.clearInterval(this.timer)
      }

      restart() {
        this.stop()
        this.start()
      }

      toggleMenu() {
        this.closeMega()
        const open = !this.classList.contains('is-menu-open')
        this.classList.toggle('is-menu-open', open)
        this.menuToggle?.setAttribute('aria-expanded', open ? 'true' : 'false')
      }

      closeMenu(returnFocus = false) {
        if (!this.classList.contains('is-menu-open')) return
        this.classList.remove('is-menu-open')
        this.menuToggle?.setAttribute('aria-expanded', 'false')
        if (returnFocus) this.menuToggle?.focus()
      }

      openMega(trigger) {
        if (window.innerWidth < 990 || !this.megaMenu || !this.megaOverlay) return
        this.activeMegaTrigger = trigger
        this.megaTriggers.forEach(item => item.setAttribute('aria-expanded', item === trigger ? 'true' : 'false'))
        const navBottom = this.siteNav?.getBoundingClientRect().bottom || 0
        this.style.setProperty('--pm-mega-top', `${Math.max(0, navBottom)}px`)
        this.megaMenu.hidden = false
        this.megaOverlay.hidden = false
        this.classList.add('is-mega-open')
        this.stop()
      }

      closeMega(returnFocus = false) {
        if (!this.classList.contains('is-mega-open')) return
        this.classList.remove('is-mega-open')
        this.megaTriggers.forEach(item => item.setAttribute('aria-expanded', 'false'))
        if (this.megaMenu) this.megaMenu.hidden = true
        if (this.megaOverlay) this.megaOverlay.hidden = true
        if (returnFocus) this.activeMegaTrigger?.focus()
        this.start()
      }
    })
  }

  if (!customElements.get('printmivo-stories')) {
    customElements.define('printmivo-stories', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return
        this.dataset.ready = 'true'
        this.track = this.querySelector('[data-pm-stories-track]')
        this.previousButton = this.querySelector('[data-pm-stories-previous]')
        this.nextButton = this.querySelector('[data-pm-stories-next]')
        if (!this.track) return
        this.onPrevious = () => this.move(-1)
        this.onNext = () => this.move(1)
        this.onScroll = () => window.requestAnimationFrame(() => this.updateControls())
        this.onResize = () => this.updateControls()
        this.onKeyDown = event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return
          event.preventDefault()
          this.move(event.key === 'ArrowRight' ? 1 : -1)
        }
        this.previousButton?.addEventListener('click', this.onPrevious)
        this.nextButton?.addEventListener('click', this.onNext)
        this.track.addEventListener('scroll', this.onScroll, { passive: true })
        this.track.addEventListener('keydown', this.onKeyDown)
        window.addEventListener('resize', this.onResize)
        this.updateControls()
      }

      disconnectedCallback() {
        this.previousButton?.removeEventListener('click', this.onPrevious)
        this.nextButton?.removeEventListener('click', this.onNext)
        this.track?.removeEventListener('scroll', this.onScroll)
        this.track?.removeEventListener('keydown', this.onKeyDown)
        window.removeEventListener('resize', this.onResize)
      }

      move(direction) {
        const cards = this.querySelectorAll('[data-pm-story-card]')
        const card = cards[0]
        if (!card || cards.length < 2) return
        const gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        const maxScroll = this.track.scrollWidth - this.track.clientWidth
        const atStart = this.track.scrollLeft <= 2
        const atEnd = this.track.scrollLeft >= maxScroll - 2

        if (direction > 0 && atEnd) {
          this.wrapTo(0)
          return
        }

        if (direction < 0 && atStart) {
          this.wrapTo(maxScroll)
          return
        }

        this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior })
      }

      wrapTo(left) {
        const previousBehavior = this.track.style.scrollBehavior
        const previousSnap = this.track.style.scrollSnapType
        this.track.style.scrollBehavior = 'auto'
        this.track.style.scrollSnapType = 'none'
        this.track.scrollLeft = left
        window.requestAnimationFrame(() => {
          this.track.style.scrollBehavior = previousBehavior
          this.track.style.scrollSnapType = previousSnap
        })
      }

      updateControls() {
        const hasMultiplePages = this.track.scrollWidth > this.track.clientWidth + 2
        if (this.previousButton) this.previousButton.disabled = !hasMultiplePages
        if (this.nextButton) this.nextButton.disabled = !hasMultiplePages
      }
    })
  }

  if (!customElements.get('printmivo-comparison')) {
    customElements.define('printmivo-comparison', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return
        this.dataset.ready = 'true'
        this.range = this.querySelector('[data-pm-comparison-range]')
        if (!this.range) return
        this.onInput = () => this.style.setProperty('--pm-compare-position', `${this.range.value}%`)
        this.range.addEventListener('input', this.onInput)
        this.onInput()
      }

      disconnectedCallback() {
        this.range?.removeEventListener('input', this.onInput)
      }
    })
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["printmivo-review-feed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('printmivo-review-feed')) {
    class PrintmivoReviewFeed extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.dialog = this.querySelector('dialog');
        this.loadMoreButton = this.querySelector('[data-review-load-more]');
        this.extraReviews = Array.from(this.querySelectorAll('[data-review-extra]'));

        this.loadMoreButton?.addEventListener('click', () => this.showMoreReviews());
        this.updateLoadMoreButton();

        if (!this.dialog) return;

        this.querySelectorAll('[data-review-dialog-open]').forEach((button) => {
          button.addEventListener('click', () => this.openDialog());
        });

        this.querySelectorAll('[data-review-dialog-close]').forEach((button) => {
          button.addEventListener('click', () => this.closeDialog());
        });

        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.closeDialog();
        });

        if (this.querySelector('[data-review-success]')) {
          this.openDialog();
          requestAnimationFrame(() => this.querySelector('[data-review-success]')?.focus());
        }
      }

      runTransition(callback) {
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (document.startViewTransition && !reducedMotion) {
          document.startViewTransition(callback);
        } else {
          callback();
        }
      }

      openDialog() {
        this.runTransition(() => {
          if (typeof this.dialog.showModal === 'function') {
            if (!this.dialog.open) this.dialog.showModal();
          } else {
            this.dialog.setAttribute('open', '');
          }
        });
      }

      closeDialog() {
        this.runTransition(() => {
          if (typeof this.dialog.close === 'function') {
            this.dialog.close();
          } else {
            this.dialog.removeAttribute('open');
          }
        });
      }

      showMoreReviews() {
        const nextReviews = this.extraReviews.filter((review) => review.hidden);
        nextReviews.forEach((review) => {
          review.hidden = false;
        });
        this.updateLoadMoreButton();
      }

      updateLoadMoreButton() {
        if (!this.loadMoreButton) return;
        this.loadMoreButton.hidden = !this.extraReviews.some((review) => review.hidden);
      }
    }

    customElements.define('printmivo-review-feed', PrintmivoReviewFeed);
  }

  } catch(e) { console.error(e); }
})();
})();
